import React from 'react';

// Overlay hit-areas (percentages of the face container) — reliable HTML buttons
const HIT_AREAS = [
  { key: 'scalp', label: 'Scalp', left: '18%', top: '6%', width: '64%', height: '16%' },
  { key: 'forehead', label: 'Forehead', left: '27%', top: '26%', width: '46%', height: '17%' },
  { key: 'cheeks', label: 'Cheek', left: '22%', top: '45%', width: '22%', height: '22%' },
  { key: 'cheeks', label: 'Cheek', left: '56%', top: '45%', width: '22%', height: '22%' },
  { key: 'nose', label: 'Nose', left: '44%', top: '45%', width: '12%', height: '18%' },
  { key: 'jawline', label: 'Jaw', left: '16%', top: '60%', width: '16%', height: '22%' },
  { key: 'jawline', label: 'Jaw', left: '68%', top: '60%', width: '16%', height: '22%' },
  { key: 'chin', label: 'Chin', left: '40%', top: '70%', width: '24%', height: '16%' },
];

const FaceMap = ({ selected = {}, onToggle }) => {
  const isOn = (k) => !!selected[k];
  const fill = (k) => (isOn(k) ? 'rgba(194,115,89,0.42)' : 'rgba(244,242,238,0.9)');
  const stroke = (k) => (isOn(k) ? '#A388EE' : '#E5D0C9');
  const vis = (k) => ({ fill: fill(k), stroke: stroke(k), strokeWidth: 2, transition: 'fill 0.25s ease, stroke 0.25s ease' });

  const activeZones = ['forehead', 'cheeks', 'nose', 'chin', 'jawline', 'scalp'].filter(isOn);

  return (
    <div className="animate-fade-in">
      <div className="relative mx-auto" style={{ width: 230 }}>
        {/* Visual face — driven by selection state, not clickable */}
        <svg viewBox="0 0 220 260" width="230" className="mx-auto drop-shadow-sm" style={{ pointerEvents: 'none', display: 'block' }}>
          <defs>
            <radialGradient id="faceBg" cx="50%" cy="38%" r="70%">
              <stop offset="0%" stopColor="#FBFAF7" />
              <stop offset="100%" stopColor="#F4F2EE" />
            </radialGradient>
          </defs>
          <path d="M40 78 C40 20 180 20 180 78 C180 60 150 40 110 40 C70 40 40 60 40 78 Z" style={vis('scalp')} />
          <path d="M48 92 C48 55 172 55 172 92 L172 150 C172 205 130 236 110 236 C90 236 48 205 48 150 Z" fill="url(#faceBg)" stroke="#E5D0C9" strokeWidth="2" />
          <path d="M50 150 C50 200 88 232 110 232 C132 232 170 200 170 150 L170 168 C170 210 130 238 110 238 C90 238 50 210 50 168 Z" style={vis('jawline')} />
          <ellipse cx="110" cy="96" rx="50" ry="24" style={vis('forehead')} />
          <ellipse cx="74" cy="150" rx="22" ry="26" style={vis('cheeks')} />
          <ellipse cx="146" cy="150" rx="22" ry="26" style={vis('cheeks')} />
          <path d="M110 128 C103 128 100 150 100 158 C100 166 120 166 120 158 C120 150 117 128 110 128 Z" style={vis('nose')} />
          <ellipse cx="110" cy="206" rx="26" ry="20" style={vis('chin')} />
          <g pointerEvents="none">
            <circle cx="88" cy="132" r="3.4" fill="#FF6B4A" />
            <circle cx="132" cy="132" r="3.4" fill="#FF6B4A" />
            <path d="M96 184 Q110 194 124 184" fill="none" stroke="#FF6B4A" strokeWidth="2.4" strokeLinecap="round" />
          </g>
        </svg>

        {/* Reliable clickable overlay */}
        {HIT_AREAS.map((a, i) => (
          <button
            key={`${a.key}-${i}`}
            onClick={() => onToggle(a.key)}
            aria-label={a.label}
            title={a.label}
            data-testid={`facemap-${a.key}-${i}`}
            className="absolute rounded-full focus:outline-none focus:ring-2 focus:ring-[#A388EE]/50"
            style={{ left: a.left, top: a.top, width: a.width, height: a.height, background: 'transparent', cursor: 'pointer' }}
          />
        ))}
      </div>

      <p className="text-center text-xs text-[#8C7A76] mt-2">Tap the areas where you're breaking out</p>

      <div className="flex items-center justify-center gap-2 mt-3 flex-wrap min-h-[28px]">
        {activeZones.length === 0 ? (
          <span className="text-xs text-[#4ADE80] font-medium">None selected</span>
        ) : (
          activeZones.map((k) => (
            <span key={k} className="px-3 py-1 rounded-full bg-[#A388EE]/12 text-[#A388EE] text-xs font-semibold capitalize flex items-center gap-1">
              {k}
              <button onClick={() => onToggle(k)} className="hover:text-[#a35a42]" aria-label={`Remove ${k}`}>×</button>
            </span>
          ))
        )}
      </div>

      {activeZones.length > 0 && (
        <div className="text-center mt-2">
          <button
            onClick={() => activeZones.forEach((k) => onToggle(k))}
            className="text-xs text-[#8C7A76] hover:text-[#FF6B4A] underline underline-offset-2"
            data-testid="facemap-clear"
          >
            Clear all
          </button>
        </div>
      )}
    </div>
  );
};

export default FaceMap;
